import { toastifyProvider } from './providers/toastify.provider';

export const notification = toastifyProvider;
